import { useState } from "react";
import { useLanguage } from "../../../Translations/LenguageContext";
import NewCollectionModal from "./Data/NewCollectionModal";
import CanvasAnimation from "../../../Components/CanvasItems";
import NewTableModal from "./SQLData/NewTableModal";
import NewUserModal from "./Users/NewUserModal";

const NoDataItem = ({ fetchRecords, title, subtitle, item, showBtn, dbType }) => {
    const { t } = useLanguage()
    const [openModal, setOpenModal] = useState(false)
    const [openModalSql, setOpenModalSql] = useState(false)
    const [openModalUsers, setOpenModalUsers] = useState(false)

    const OpenSelectedModal = () => {
        if (dbType == "sql") {
            setOpenModalSql(true)
            setOpenModal(false)
            setOpenModalUsers(false)
        } else if (dbType == "users") {
            setOpenModalUsers(true)
            setOpenModal(false)
            setOpenModalSql(false)

        } else {
            setOpenModal(true)
            setOpenModalSql(false)
            setOpenModalUsers(false)
        }
    }

    return (
        <div className="empty_cont">
            <div className="icon_cont">
                <p className="icon_cont_title">{title}</p>
                <p className="icon_cont_subtitle">{subtitle}</p>

                {item != "" && (
                    <div className="canvas_anim_empty_cont">
                        <CanvasAnimation type={item} />
                    </div>
                )}
            </div>
            {showBtn && (
                <div className="btn_cont">
                    <button className="connect_email_btn" onClick={OpenSelectedModal}><i className="fa-solid fa-plus"></i> {t.create}</button>
                </div>
            )}
            <NewCollectionModal
                show={openModal}
                handleClose={() => setOpenModal(false)}
                fetchRecords={fetchRecords}
            />
            <NewTableModal
                show={openModalSql}
                handleClose={() => setOpenModalSql(false)}
                fetchRecords={fetchRecords}
            />
            <NewUserModal
                show={openModalUsers}
                handleClose={() => setOpenModalUsers(false)}
                fetchRecords={fetchRecords}
            />
        </div>
    )
}

export default NoDataItem